import { render, staticRenderFns } from "./Adjectives.vue?vue&type=template&id=189bb086&"
import script from "./Adjectives.vue?vue&type=script&lang=js&"
export * from "./Adjectives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports